import React from 'react'
import { Switch } from 'react-router-dom'
import Loadable from './Loadable'
import RoutePermission from '../../../lib/routePermission'

const AsyncHome = Loadable({
	loader: () => import('../components/Home')
})

const AsyncNotFound = Loadable({
	loader: () => import('../components/NotFound')
})

const AsyncLoginBSRS = Loadable({
	loader: () => import('../../auth/components/LoginBSRS')
})

const AsyncSettings = Loadable({
	loader: () => import('../components/Settings')
})

const AsyncSettingsIntegration = Loadable({
	loader: () => import('../../settings/integration/components/SettingIntegration')
})

const AsyncCreateRoom = Loadable({
	loader: () => import('../../settings/room/components/CreateRoom')
})

const AsyncUpdateRoom = Loadable({
	loader: () => import('../../settings/room/components/UpdateRoom')
})

const AsyncSettingsRoom = Loadable({
	loader: () => import('../../settings/room/components/ListRoom')
})

const AsyncLoginO365 = Loadable({
	loader: () => import('../../auth/components/LoginO365')
})

const AsyncAuthorizeO365 = Loadable({
	loader: () => import('../../auth/components/AuthorizeO365')
})

const AsyncCheckRoomInCore = Loadable({
	loader: () => import('../../settings/room/components/CheckRoomInCore')
})

const AsyncRoomInCore = Loadable({
	loader: () => import('../../settings/room/components/ListCore')
})

const AsyncUserList = Loadable({
	loader: () => import('../../settings/user/components/UserList')
})

const AsyncUserAdd = Loadable({
	loader: () => import('../../settings/user/components/UserAdd')
})

const AsyncUserEdit = Loadable({
	loader: () => import('../../settings/user/components/UserEdit')
})

const AsyncUserchangePass = Loadable({
	loader: () => import('../../settings/user/components/UserChangePass')
})


const AsyncUserInfo = Loadable({
	loader: () => import('../../user/components/UserInfo')
})

const AsyncUserChangePassword = Loadable({
	loader: () => import('../../user/components/UserChangePassword')
})

const AsyncReportSummary = Loadable({
	loader: () => import('../../report/components/ReportSummary')
})

const AsyncUserReport = Loadable({
	loader: () => import('../../report/components/UserReport')
})

const AsyncRoomReportNew = Loadable({
	loader: () => import('../../report/components/RoomReportNew')
})

const AsyncUserSummary = Loadable({
	loader: () => import('../../report/components/UserSummary')
})

const AsyncRoomSummary = Loadable({
	loader: () => import('../../report/components/RoomSummary')
})

const AsyncFacilitySummary = Loadable({
	loader: () => import('../../report/components/FacilitySummary')
})

const AsyncReserveNotUseByUser = Loadable({
	loader: () => import('../../report/components/ReserveNotUseByUser')
})

const AsyncReserveNotUseByRoom = Loadable({
	loader: () => import('../../report/components/ReserveNotUseByRoom')
})

const AsyncFoodSummary = Loadable({
	loader: () => import('../../report/components/FoodSummary')
})

const AsyncDeleteEventSummary = Loadable({
	loader: () => import('../../report/components/DeleteEventSummary')
})


// const AsyncSetting = Loadable({
// 	loader: () => import('../../setting/components/updateSetting')
// })

const AsyncSetting = Loadable({
	loader: () => import('../../setting/components/updateNewSetting')
})

// const AsyncChangeSetting = Loadable({
// 	loader: () => import('../../setting/components/updateSetting')
// })

const AsyncListRoomsO365 = Loadable({
	loader: () => import('../../rooms/components/ListRoomsO365')
})

const AsyncListRoomsCore = Loadable({
	loader: () => import('../../rooms/components/ListRoomsCore')
})

const AsyncListRoomsSubscribe = Loadable({
	loader: () => import('../../rooms/components/ListRoomsSubscribe')
})

const AsyncCreateRoomNew = Loadable({
	loader: () => import('../../rooms/components/CreateRoom')
})

const AsyncUpdateRoomNew = Loadable({
	loader: () => import('../../rooms/components/UpdateRoom')
})

const AsyncViewRoomCore = Loadable({
	loader: () => import('../../rooms/components/ViewRoomCore')
})

const AsyncListUsersCore = Loadable({
	loader: () => import('../../user/components/ListUsersCore')
})

const AsyncListUsersO365 = Loadable({
	loader: () => import('../../user/components/ListUsersO365')
})

const AsyncListUsersAD = Loadable({
	loader: () => import('../../user/components/ListUsersAd')
})

const AsyncCreateUser = Loadable({
	loader: () => import('../../user/components/CreateUser')
})

const AsyncUpdateUser = Loadable({
	loader: () => import('../../user/components/UpdateUser')
})

const AsyncViewUserCore = Loadable({
	loader: () => import('../../user/components/ViewUserCore')
})

const AsyncAmenity = Loadable({
	loader: () => import('../../settings/amenity/components/ListAmenity')
})

const AsyncAmenityUpdate = Loadable({
	loader: () => import('../../settings/amenity/components/UpdateAmenity')
})

const AsyncViewAmenity = Loadable({
	loader: () => import('../../settings/amenity/components/ViewAmenity')
})

const AsyncAmenityCreate = Loadable({
	loader: () => import('../../settings/amenity/components/CreateAmenity')
})

const AsyncBuildingCreate = Loadable({
	loader: () => import('../../location/building/components/CreateBuilding')
})
const AsyncBuildingUpdate = Loadable({
	loader: () => import('../../location/building/components/UpdateBuilding')
})
const AsyncViewBuilding = Loadable({
	loader: () => import('../../location/building/components/ViewBuilding')
})
const AsyncBuilding = Loadable({
	loader: () => import('../../location/building/components/ListBuilding')
})

const AsyncBackgroundCreate = Loadable({
	loader: () => import('../../background/components/CreateBackground')
})
const AsyncBackgroundUpdate = Loadable({
	loader: () => import('../../background/components/UpdateBackground')
})
const AsyncViewBackground = Loadable({
	loader: () => import('../../background/components/ViewBackground')
})
const AsyncBackground = Loadable({
	loader: () => import('../../background/components/ListBackground')
})

const AsyncFloorCreate = Loadable({
	loader: () => import('../../location/floor/components/CreateFloor')
})
const AsyncFloorUpdate = Loadable({
	loader: () => import('../../location/floor/components/UpdateFloor')
})
const AsyncViewFloor = Loadable({
	loader: () => import('../../location/floor/components/ViewFloor')
})
const AsyncFloor = Loadable({
	loader: () => import('../../location/floor/components/ListFloor')
})

const AsyncZoneCreate = Loadable({
	loader: () => import('../../location/zone/components/CreateZone')
})
const AsyncZoneUpdate = Loadable({
	loader: () => import('../../location/zone/components/UpdateZone')
})
const AsyncViewZone = Loadable({
	loader: () => import('../../location/zone/components/ViewZone')
})
const AsyncZone = Loadable({
	loader: () => import('../../location/zone/components/ListZone')
})

const AsyncFbs = Loadable({
	loader: () => import('../../settings/fbs/components/ListFbs')
})

const AsyncFbsUpdate = Loadable({
	loader: () => import('../../settings/fbs/components/UpdateFbs')
})

const AsyncViewFbs = Loadable({
	loader: () => import('../../settings/fbs/components/ViewFbs')
})

const AsyncFbsCreate = Loadable({
	loader: () => import('../../settings/fbs/components/CreateFbs')
})

const AsyncListUserGroup = Loadable({
	loader: () => import('../../usergroup/components/ListUserGroup')
})

const AsyncCreateUserGroup = Loadable({
	loader: () => import('../../usergroup/components/CreateUserGroup')
})

const AsyncUpdateUserGroup = Loadable({
	loader: () => import('../../usergroup/components/UpdateUserGroup')
})

const AsyncViewUserGroup = Loadable({
	loader: () => import('../../usergroup/components/ViewUserGroup')
})

const AsyncCreateProfile = Loadable({
	loader: () => import('../../profile/components/CreateProfile')
})

const AsyncListProfile = Loadable({
	loader: () => import('../../profile/components/ListProfile')
})

const AsyncUpdateProfile = Loadable({
	loader: () => import('../../profile/components/UpdateProfile')
})

const AsyncViewProfile = Loadable({
	loader: () => import('../../profile/components/ViewProfile')
})

const AsyncIntegrations = Loadable({
	loader: () => import('../../settings/integration/components/Integrations')
})

const AsyncReportOverview = Loadable({
	loader: () => import('../../report/components/Overview')
})

const AsyncReportByRoom = Loadable({
	loader: () => import('../../report/components/Byroom')
})

const AsyncReportByUser = Loadable({
	loader: () => import('../../report/components/Byuser')
})

const AsyncReportRoomDetail = Loadable({
	loader: () => import('../../report/components/ReportRoomStatus')
})

const AsyncReportUserDetail = Loadable({
	loader: () => import('../../report/components/ReportUserDetail')
})

const AsyncReportOverviewDetail = Loadable({
	loader: () => import('../../report/components/OverviewDetail')
})

const AsyncTerm = Loadable({
	loader: () => import('../../settings/term/components/Term')
})

const AsyncEditTerm = Loadable({
	loader: () => import('../../settings/term/components/TermForm')
})

const AsyncFaq = Loadable({
	loader: () => import('../../settings/faq/components/Faq')
})

const AsyncEditFaq = Loadable({
	loader: () => import('../../settings/faq/components/FaqForm')
})

const AsyncContactUs = Loadable({
	loader: () => import('../../settings/contact/components/Contact')
})

const AsyncEditContactUs = Loadable({
	loader: () => import('../../settings/contact/components/ContactForm')
})

const AsyncFbsCategory = Loadable({
	loader: () => import('../../fbCategory/components/fbCategoryList')
})

const AsyncUpdateFbsCategory = Loadable({
	loader: () => import('../../fbCategory/components/fbCategoryUpdate')
})

const AsyncCreateFbsCategory = Loadable({
	loader: () => import('../../fbCategory/components/fbCategoryCreate')
})
const AsyncFbsCategoryView = Loadable({
	loader: () => import('../../fbCategory/components/View')
})

const AsyncIot = Loadable({
	loader: () => import('../../iot/components/iotList')
})

const AsyncIotView = Loadable({
	loader: () => import('../../iot/components/iotView')
})

const AsyncIotUpdate = Loadable({
	loader: () => import('../../iot/components/iotManageItem')
})

const AsyncExchangeIntegrations = Loadable({
	loader: () => import('../../settings/integration/components/ExchangeIntegration')
})

const AsyncGoogleIntegrations = Loadable({
	loader: () => import('../../settings/integration/components/GoogleIntegration')
})

const AsyncSettingsGoogleIntegration = Loadable({
	loader: () => import('../../settings/integration/components/SettingGoogleIntegration')
})

const AsyncSettingsExchangeIntegration = Loadable({
	loader: () => import('../../settings/integration/components/SettingExchangeIntegration')
})

const AsyncRegisterSeat = Loadable({
	loader: () => import('../../hotseat/components/pages/hotseatListNew')
})

// const AsyncDisableSeat = Loadable({
// 	loader: () => import('../../hotseat/components/pages/disableHotseatList')
// })

// const AsyncDisableSeatCreate = Loadable({
// 	loader: () => import('../../hotseat/components/pages/createDisableSeat')
// })

// const AsyncDisableSeatUpdate = Loadable({
// 	loader: () => import('../../hotseat/components/pages/updateDisableSeat')
// })

const AsyncUpdateRegisterSeat = Loadable({
	loader: () => import('../../hotseat/components/pages/updateHotseat')
})

const AsyncSeatQRCode = Loadable({
	loader: () => import('../../hotseat/components/pages/SeatQRCode')
})

const AsyncCreateRegisterSeat = Loadable({
	loader: () => import('../../hotseat/components/pages/createHotseat')
})

const AsyncRoomQRCode = Loadable({
	loader: () => import('../../rooms/components/RoomQRCode')
})

const AsyncAdminViewEvents = Loadable({
	loader: () => import('../../events/components/viewEvents')
})

const AsyncIotRoomRegis = Loadable({
	loader: () => import('../../iotRoomRegis/components/iotRoomRegisList')
})

const AsyncIotRoomRegisUpdate = Loadable({
	loader: () => import('../../iotRoomRegis/components/iotUpdate')
})

const AsyncIotRoomRegisView = Loadable({
	loader: () => import('../../iotRoomRegis/components/iotView')
})

const AsyncIotRoomRegisCreate = Loadable({
	loader: () => import('../../iotRoomRegis/components/iotCreate')
})

const AsyncDisplayList = Loadable({
	loader: () => import('../../display/components/displayList')
})

const AsyncRoomDisableList = Loadable({
	loader: () => import('../../roomDisable/components/roomDisableList')
})

const AsyncRoomDisableCreate = Loadable({
	loader: () => import('../../roomDisable/components/roomDisableCreate')
})

const AsyncRoomDisableUpdate = Loadable({
	loader: () => import('../../roomDisable/components/roomDisableUpdate')
})

const AsyncRoomDisableView = Loadable({
	loader: () => import('../../roomDisable/components/roomDisableView')
})

const AsyncConcurrentList = Loadable({
	loader: () => import('../../concurrent/components/ConcurrentList')
})

const AsyncRoleList = Loadable({
	loader: () => import('../../roles/components/List')
})

const AsyncRoleCreate = Loadable({
	loader: () => import('../../roles/components/Create')
})

const AsyncRoleView = Loadable({
	loader: () => import('../../roles/components/View')
})

const AsyncRoleUpdate = Loadable({
	loader: () => import('../../roles/components/Update')
})

const AsyncRoomFormatList = Loadable({
	loader: () => import('../../roomFormat/components/List')
})

const AsyncRoomFormatListCreate = Loadable({
	loader: () => import('../../roomFormat/components/Create')
})

const AsyncRoomFormatListView = Loadable({
	loader: () => import('../../roomFormat/components/View')
})

const AsyncRoomFormatListUpdate = Loadable({
	loader: () => import('../../roomFormat/components/Update')
})

const AsyncOrderFbsList = Loadable({
	loader: () => import('../../order/components/ListFbs')
})

const AsyncOrderFbsUpdate = Loadable({
	loader: () => import('../../order/components/UpdateFbs')
})

const AsyncOrderCreateFbs = Loadable({
	loader: () => import('../../order/components/CreateFbs')
})

const AsyncOrderCreateAmenity = Loadable({
	loader: () => import('../../order/components/CreateAmenity')
})

const AsyncOrderAmenityList = Loadable({
	loader: () => import('../../order/components/ListAmenity')
})

const AsyncOrderAmenityUpdate = Loadable({
	loader: () => import('../../order/components/UpdateAmenity')
})

const AsyncReportFoodSummaryByEvent = Loadable({
	loader: () => import('../../report/components/FoodSummaryByEvent')
})

const AsyncReportFacilitySummaryByEvent = Loadable({
	loader: () => import('../../report/components/FacilitySummaryByEvent')
})

const AsyncViewEventsOrder = Loadable({
	loader: () => import('../../order/components/viewEvents')
})

const AsyncEventTypeList = Loadable({
	loader: () => import('../../eventType/components/List')
})

const AsyncEventTypeView = Loadable({
	loader: () => import('../../eventType/components/View')
})

const AsyncEventTypeCreate = Loadable({
	loader: () => import('../../eventType/components/Create')
})

const AsyncEventTypeUpdate = Loadable({
	loader: () => import('../../eventType/components/Update')
})

const AsyncHotdeskViewTemporaryClosedList = Loadable({
	loader: () => import('../../hotdeskTemporaryClosed/components/pages/listTemporaryClosed')
})

const AsyncHotdeskViewTemporaryClosed = Loadable({
	loader: () => import('../../hotdeskTemporaryClosed/components/pages/view')
})

const AsyncHotdeskCreateTemporaryClosed = Loadable({
	loader: () => import('../../hotdeskTemporaryClosed/components/pages/create')
})

const AsyncHotdeskUpdateTemporaryClosed = Loadable({
	loader: () => import('../../hotdeskTemporaryClosed/components/pages/update')
})

const AsyncHotdeskCreateRole = Loadable({
	loader: () => import('../../hotdeskRole/components/pages/createRole')
})
const AsyncHotdeskUpdateRole = Loadable({
	loader: () => import('../../hotdeskRole/components/pages/updateRole')
})
const AsyncHotdeskViewRole = Loadable({
	loader: () => import('../../hotdeskRole/components/pages/viewRole')
})
const AsyncHotdeskRoleList = Loadable({
	loader: () => import('../../hotdeskRole/components/pages/roleList')
})

const AsyncAvailableTimeSlotList = Loadable({
	loader: () => import('../../hotdeskAvailableTimeSlot/components/pages/availableTimeSlotList')
})
const AsyncCreateAvailableTimeSlot = Loadable({
	loader: () => import('../../hotdeskAvailableTimeSlot/components/pages/createAvailableTimeSlot')
})
const AsyncUpdateAvailableTimeSlot = Loadable({
	loader: () => import('../../hotdeskAvailableTimeSlot/components/pages/updateAvailableTimeSlot')
})
const AsyncViewAvailableTimeSlot = Loadable({
	loader: () => import('../../hotdeskAvailableTimeSlot/components/pages/viewAvailableTimeSlot')
})

const AsyncAllControlList = Loadable({
	loader: () => import('../../allControl/components/pages/allControlList')
})
const LogoSetting = Loadable({
	loader: () => import('../../setting/components/Logo')
})

const LogoUpdateSetting = Loadable({
	loader: () => import('../../setting/components/LogoUpdate')
})
const SessionExpire = Loadable({
	loader: ()=> import("./TokenExpireDialog")
})
export default () => (
	<Switch>
		<RoutePermission.PrivateRoute exact path='/' component={AsyncHome} />
		<RoutePermission.PrivateRoute path='/integration' component={AsyncIntegrations} />
		<RoutePermission.PrivateRoute path='/exchangeIntegration' component={AsyncExchangeIntegrations} />
		<RoutePermission.PrivateRoute path='/googleIntegration' component={AsyncGoogleIntegrations} />
		<RoutePermission.PublicRoute path='/login' component={AsyncLoginBSRS} />
		<RoutePermission.PublicRoute path='/sessionExpire' component={SessionExpire} />
		
		<RoutePermission.PrivateRoute path='/settings/integration' component={AsyncSettingsIntegration} />
		<RoutePermission.PrivateRoute path='/settings/googleIntegration' component={AsyncSettingsGoogleIntegration} />
		<RoutePermission.PrivateRoute path='/settings/exchangeIntegration' component={AsyncSettingsExchangeIntegration} />
		<RoutePermission.PrivateRoute path="/settings/room/create/:email" component={AsyncCreateRoom} />
		<RoutePermission.PrivateRoute path="/settings/room/update/:email" component={AsyncUpdateRoom} />
		<RoutePermission.PrivateRoute path="/term" component={AsyncTerm} />
		<RoutePermission.PrivateRoute path="/editterm" component={AsyncEditTerm} />
		<RoutePermission.PrivateRoute path="/regisseat/create/:id" component={AsyncCreateRegisterSeat} />
		<RoutePermission.PrivateRoute path="/regisseat/update/:id" component={AsyncUpdateRegisterSeat} />
		<RoutePermission.PrivateRoute path="/regisseat/qrcode/:id" component={AsyncSeatQRCode} />

		{/* <RoutePermission.PrivateRoute path="/registerseat/disable/update/:id" component={AsyncDisableSeatUpdate} />
		<RoutePermission.PrivateRoute path="/registerseat/disable/create" component={AsyncDisableSeatCreate} />
		<RoutePermission.PrivateRoute path="/registerseat/disable" component={AsyncDisableSeat} /> ********ปิดเมนู ต้องลบ code */}
		<RoutePermission.PrivateRoute path="/registerseat" component={AsyncRegisterSeat} />
		<RoutePermission.PrivateRoute path="/faq" component={AsyncFaq} />
		<RoutePermission.PrivateRoute path="/editfaq" component={AsyncEditFaq} />
		<RoutePermission.PrivateRoute path="/contact" component={AsyncContactUs} />
		<RoutePermission.PrivateRoute path="/editcontact" component={AsyncEditContactUs} />
		<RoutePermission.PrivateRoute path='/setting' component={AsyncSetting} />
		{/* <RoutePermission.PrivateRoute path='/changesetting' component={AsyncChangeSetting} /> */}
		<RoutePermission.PrivateRoute path="/room/system" component={AsyncListRoomsO365} />
		<RoutePermission.PrivateRoute path="/room/core/qrcode/:email" component={AsyncRoomQRCode} />
		<RoutePermission.PrivateRoute path="/room/core" component={AsyncListRoomsCore} />
		<RoutePermission.PrivateRoute path="/room/subscribe" component={AsyncListRoomsSubscribe} />
		<RoutePermission.PrivateRoute path="/room/create" component={AsyncCreateRoomNew} />
		<RoutePermission.PrivateRoute path="/room/update/:email" component={AsyncUpdateRoomNew} />
		<RoutePermission.PrivateRoute path="/room/view/:email" component={AsyncViewRoomCore} />
		<RoutePermission.PrivateRoute path="/user/o365" component={AsyncListUsersO365} />
		<RoutePermission.PrivateRoute path="/user/ad" component={AsyncListUsersAD} />
		<RoutePermission.PrivateRoute path="/user/core" component={AsyncListUsersCore} />
		<RoutePermission.PrivateRoute path="/user/create" component={AsyncCreateUser} />
		<RoutePermission.PrivateRoute path="/user/update/:id" component={AsyncUpdateUser} />
		<RoutePermission.PrivateRoute path="/user/view/:id" component={AsyncViewUserCore} />

		<RoutePermission.PrivateRoute path="/user/group/list" component={AsyncListUserGroup} />
		<RoutePermission.PrivateRoute path="/user/group/create" component={AsyncCreateUserGroup} />
		<RoutePermission.PrivateRoute path="/user/group/update/:id" component={AsyncUpdateUserGroup} />
		<RoutePermission.PrivateRoute path="/user/group/view/:id" component={AsyncViewUserGroup} />
		
		<RoutePermission.PrivateRoute path="/profile/list" component={AsyncListProfile} />
		<RoutePermission.PrivateRoute path="/profile/create" component={AsyncCreateProfile} />
		<RoutePermission.PrivateRoute path="/profile/update/:id" component={AsyncUpdateProfile} />
		<RoutePermission.PrivateRoute path="/profile/view/:id" component={AsyncViewProfile} />
		<RoutePermission.PrivateRoute path="/amenity/create" component={AsyncAmenityCreate} />
		<RoutePermission.PrivateRoute path="/amenity/update/:id" component={AsyncAmenityUpdate} />
		<RoutePermission.PrivateRoute path="/amenity/view/:id" component={AsyncViewAmenity} />
		<RoutePermission.PrivateRoute path="/amenity" component={AsyncAmenity} />
		<RoutePermission.PrivateRoute path="/building/create" component={AsyncBuildingCreate} />
		<RoutePermission.PrivateRoute path="/building/update/:id" component={AsyncBuildingUpdate} />
		<RoutePermission.PrivateRoute path="/building/view/:id" component={AsyncViewBuilding} />
		<RoutePermission.PrivateRoute path="/building" component={AsyncBuilding} />
		<RoutePermission.PrivateRoute path="/background/create" component={AsyncBackgroundCreate} />
		<RoutePermission.PrivateRoute path="/background/update/:id" component={AsyncBackgroundUpdate} />
		<RoutePermission.PrivateRoute path="/background/view/:id" component={AsyncViewBackground} />
		<RoutePermission.PrivateRoute path="/background" component={AsyncBackground} />
		<RoutePermission.PrivateRoute path="/floor/create" component={AsyncFloorCreate} />
		<RoutePermission.PrivateRoute path="/floor/update/:id" component={AsyncFloorUpdate} />
		<RoutePermission.PrivateRoute path="/floor/view/:id" component={AsyncViewFloor} />
		<RoutePermission.PrivateRoute path="/floor" component={AsyncFloor} />
		<RoutePermission.PrivateRoute path="/zone/create" component={AsyncZoneCreate} />
		<RoutePermission.PrivateRoute path="/zone/update/:id" component={AsyncZoneUpdate} />
		<RoutePermission.PrivateRoute path="/zone/view/:id" component={AsyncViewZone} />
		<RoutePermission.PrivateRoute path="/zone" component={AsyncZone} />

		<RoutePermission.PrivateRoute path="/eventtype/create" component={AsyncEventTypeCreate} />
		<RoutePermission.PrivateRoute path="/eventtype/update/:id" component={AsyncEventTypeUpdate} />
		<RoutePermission.PrivateRoute path="/eventtype/view/:id" component={AsyncEventTypeView} />
		<RoutePermission.PrivateRoute path="/eventtype" component={AsyncEventTypeList} />

		<RoutePermission.PrivateRoute path="/role/view/:id" component={AsyncRoleView} />
		<RoutePermission.PrivateRoute path="/role/update/:id" component={AsyncRoleUpdate} />
		<RoutePermission.PrivateRoute path="/role/list" component={AsyncRoleList} />
		<RoutePermission.PrivateRoute path="/role/create" component={AsyncRoleCreate} />

		<RoutePermission.PrivateRoute path="/fbsCategory/update/:id" component={AsyncUpdateFbsCategory} />
		<RoutePermission.PrivateRoute path="/fbsCategory/create" component={AsyncCreateFbsCategory} />
		<RoutePermission.PrivateRoute path="/fbsCategory/:id" component={AsyncFbsCategoryView} />
		<RoutePermission.PrivateRoute path="/fbsCategory" component={AsyncFbsCategory} />
		<RoutePermission.PrivateRoute path="/fbs/create" component={AsyncFbsCreate} />
		<RoutePermission.PrivateRoute path="/fbs/update/:id" component={AsyncFbsUpdate} />
		<RoutePermission.PrivateRoute path="/fbs/view/:id" component={AsyncViewFbs} />
		<RoutePermission.PrivateRoute path="/fbs" component={AsyncFbs} />
		<RoutePermission.PrivateRoute path='/settings' component={AsyncSettings} />
		<RoutePermission.PrivateRoute path="/room/list" component={AsyncSettingsRoom} />
		<RoutePermission.PrivateRoute path='/logino365' component={AsyncLoginO365} />
		<RoutePermission.PrivateRoute path='/authorize' component={AsyncAuthorizeO365} />
		<RoutePermission.PrivateRoute path='/checkroom/:email' component={AsyncCheckRoomInCore} />
		<RoutePermission.PrivateRoute path='/userInfo' component={AsyncUserInfo} />
		<RoutePermission.PrivateRoute path='/user/changepassword/:id' component={AsyncUserChangePassword} />
		<RoutePermission.PrivateRoute path='/core/myroom' component={AsyncRoomInCore} />
		<RoutePermission.PrivateRoute path='/report/overview/:type/:range' component={AsyncReportOverviewDetail} />
		<RoutePermission.PrivateRoute path='/report/user/:id' component={AsyncReportUserDetail} />
		<RoutePermission.PrivateRoute path='/report/room/:email' component={AsyncReportRoomDetail} />
		<RoutePermission.PrivateRoute path='/report/statussummary' component={AsyncReportSummary} />
		<RoutePermission.PrivateRoute path='/report/overview' component={AsyncReportOverview} />
		<RoutePermission.PrivateRoute path='/report/byroom' component={AsyncReportByRoom} />
		<RoutePermission.PrivateRoute path='/report/byuser' component={AsyncReportByUser} />
		<RoutePermission.PrivateRoute path='/report/roomreport' component={AsyncRoomReportNew} />
		<RoutePermission.PrivateRoute path='/report/userreport' component={AsyncUserReport} />
		<RoutePermission.PrivateRoute path='/report/usersummary' component={AsyncUserSummary} />
		<RoutePermission.PrivateRoute path='/report/roomsummary' component={AsyncRoomSummary} />
		<RoutePermission.PrivateRoute path='/report/deleteeventsummary' component={AsyncDeleteEventSummary} />

		<RoutePermission.PrivateRoute path='/report/foodsummary' component={AsyncFoodSummary} />
		<RoutePermission.PrivateRoute path='/report/facilitysummary' component={AsyncFacilitySummary} />

		<RoutePermission.PrivateRoute path='/report/foodsummarybyevent' component={AsyncReportFoodSummaryByEvent} />
		<RoutePermission.PrivateRoute path='/report/facilitysummarybyevent' component={AsyncReportFacilitySummaryByEvent} />

		<RoutePermission.PrivateRoute path='/report/notuse/user' component={AsyncReserveNotUseByUser} />
		<RoutePermission.PrivateRoute path='/report/notuse/room' component={AsyncReserveNotUseByRoom} />

		<RoutePermission.PrivateRoute path="/setting/user/list" component={AsyncUserList} />
		<RoutePermission.PrivateRoute path="/setting/user/add" component={AsyncUserAdd} />
		<RoutePermission.PrivateRoute path="/setting/user/edit/:id" component={AsyncUserEdit} />
		<RoutePermission.PrivateRoute path="/setting/user/changepass/:id" component={AsyncUserchangePass} />

		<RoutePermission.PrivateRoute path="/iotView/:id" component={AsyncIotView} />
		<RoutePermission.PrivateRoute path="/iotUpdate/:id" component={AsyncIotUpdate} />

		<RoutePermission.PrivateRoute path="/iot" component={AsyncIot} />

		<RoutePermission.PrivateRoute path="/iotRoom/update/:id" component={AsyncIotRoomRegisUpdate} />
		<RoutePermission.PrivateRoute path="/iotRoom/view/:id" component={AsyncIotRoomRegisView} />
		<RoutePermission.PrivateRoute path="/iotRoom/create" component={AsyncIotRoomRegisCreate} />
		<RoutePermission.PrivateRoute path="/iotRoom" component={AsyncIotRoomRegis} />

		<RoutePermission.PrivateRoute path="/display" component={AsyncDisplayList} />

		<RoutePermission.PrivateRoute path="/roomdisable/update/:id" component={AsyncRoomDisableUpdate} />
		<RoutePermission.PrivateRoute path="/roomdisable/view/:id" component={AsyncRoomDisableView} />
		<RoutePermission.PrivateRoute path="/roomdisable/create" component={AsyncRoomDisableCreate} />
		<RoutePermission.PrivateRoute path="/roomdisable" component={AsyncRoomDisableList} />

		<RoutePermission.PrivateRoute path="/user/concurrent" component={AsyncConcurrentList} />

		<RoutePermission.PrivateRoute path="/roomformat/view/:id" component={AsyncRoomFormatListView} />
		<RoutePermission.PrivateRoute path="/roomformat/update/:id" component={AsyncRoomFormatListUpdate} />
		<RoutePermission.PrivateRoute path="/roomformat/create" component={AsyncRoomFormatListCreate} />
		<RoutePermission.PrivateRoute path="/roomformat" component={AsyncRoomFormatList} />

		<RoutePermission.PrivateRoute path="/orderfbs/create/:icaluid/:roomemail" component={AsyncOrderCreateFbs} />
		<RoutePermission.PrivateRoute path="/orderfbs/update/:id" component={AsyncOrderFbsUpdate} />
		<RoutePermission.PrivateRoute path="/order" component={AsyncOrderFbsList} />

		<RoutePermission.PrivateRoute path="/orderamenity/create/:icaluid/:roomemail" component={AsyncOrderCreateAmenity} />
		<RoutePermission.PrivateRoute path="/orderamenity/update/:id" component={AsyncOrderAmenityUpdate} />
		<RoutePermission.PrivateRoute path="/orderamenity" component={AsyncOrderAmenityList} />

		<RoutePermission.PrivateRoute path="/events/order" component={AsyncViewEventsOrder} />
		<RoutePermission.PrivateRoute path="/events" component={AsyncAdminViewEvents} />

		<RoutePermission.PrivateRoute path="/hotdesk/temporaryclosed/update/:id" component={AsyncHotdeskUpdateTemporaryClosed} />
		<RoutePermission.PrivateRoute path="/hotdesk/temporaryclosed/create" component={AsyncHotdeskCreateTemporaryClosed} />
		<RoutePermission.PrivateRoute path="/hotdesk/temporaryclosed/:id" component={AsyncHotdeskViewTemporaryClosed} />
		<RoutePermission.PrivateRoute path="/hotdesk/temporaryclosed" component={AsyncHotdeskViewTemporaryClosedList} />

		<RoutePermission.PrivateRoute path="/hotdesk/role/view/:id" component={AsyncHotdeskViewRole} />
		<RoutePermission.PrivateRoute path="/hotdesk/role/update/:id" component={AsyncHotdeskUpdateRole} />
		<RoutePermission.PrivateRoute path="/hotdesk/role/create" component={AsyncHotdeskCreateRole} />
		<RoutePermission.PrivateRoute path="/hotdesk/role" component={AsyncHotdeskRoleList} />

		<RoutePermission.PrivateRoute path="/hotdesk/availabletimeslot/view/:id" component={AsyncViewAvailableTimeSlot} />
		<RoutePermission.PrivateRoute path="/hotdesk/availabletimeslot/update/:id" component={AsyncUpdateAvailableTimeSlot} />
		<RoutePermission.PrivateRoute path="/hotdesk/availabletimeslot/create" component={AsyncCreateAvailableTimeSlot} />
		<RoutePermission.PrivateRoute path="/hotdesk/availabletimeslot" component={AsyncAvailableTimeSlotList} />

		<RoutePermission.PrivateRoute path="/logo/update" component={LogoUpdateSetting} />
		<RoutePermission.PrivateRoute path="/logo" component={LogoSetting} />

		<RoutePermission.PrivateRoute path="/allcontrol" component={AsyncAllControlList} />
		
		<RoutePermission.PrivateRoute component={AsyncNotFound} />
	</Switch>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Routes.js